<template>
  <div class="bt-anggota pa-5">
    <div class="bth-rembug-box">
      <v-card class="overflow-hidden elevation-3 rounded-lg mb-3">
        <v-card-text>
          <v-autocomplete :color="$vuetify.theme.dark
            ? 'background-color: white'
            : 'background-color: black'
            " label="Hari" class="mb-4 font-weight-medium" hide-details :items="opt_hari" item-text="day_name"
            item-value="day_code" v-model="selectedItem" @change="getRembug(selectedItem)" />
          <v-menu ref="menu" v-model="dateShow" :close-on-content-click="false" :return-value.sync="transaction_date"
            transition="scale-transition" offset-y min-width="auto" :color="$vuetify.theme.dark
              ? 'background-color: white'
              : 'background-color: black'
              ">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="transaction_date" class="font-weight-medium" label="Tanggal" readonly
                v-bind="attrs" v-on="on" />
            </template>
            <v-date-picker v-model="transaction_date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateShow = false"> Cancel </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(transaction_date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>
      <v-card v-for="(rbg, rbgIndex) in rembug" :key="rbgIndex" class="mb-4 card-modern">
        <v-row>
          <!-- HEADER -->
          <v-col cols="8" class="align-center">
            <div class="d-flex align-center">
              <div class="text-uppercase text-lg font-weight-bold">
                Kp. {{ rbg.cm_name }}
              </div>
            </div>
            <div class="mb-4 mt-1">
              <span class="text-caption grey--text">
                {{ rbg.desa }}
              </span>
            </div>
            <!-- CONTENT -->
          </v-col>
          <v-col cols="4" class="text-right">
            <div>
              <span class="anggota-count text-h5 font-weight-bold">
                {{ rbg.jumlah }}
              </span>
            </div>
            <div class="d-flex justify-end mb-4">
              <span class="text-caption grey--text">
                Jumlah Anggota
              </span>
            </div>
          </v-col>
        </v-row>
        <router-link :to="transaction_date !== null
          ? `/tabungan/kelompok/${rbg.cm_code}/${rbg.branch_id}/${transaction_date}`
          : ''">
          <v-btn block class="btn-modern" :disabled="transaction_date === null">
            <v-icon left small>mdi-eye</v-icon>
            Lihat Kumpulan
          </v-btn>
        </router-link>
      </v-card>
    </div>
    <v-row class="mt-5">
      <v-col cols="12" class="pb-5 mb-5">
        <router-link to="/dtl/dashboard">
          <v-btn block class="purple lighten-1 white--text">Kembali </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-snackbar v-model="alert.show" :timeout="5000">
      {{ alert.msg }}
    </v-snackbar>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Toast from "@/components/Toast";
import services from "@/services";
import helper from "@/utils/helper";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  components: {
    Toast,
    Header,
  },
  data() {
    return {
      rembug: [],
      selectedItem: null,
      transaction_date: null,
      dateShow: false,
      opt_hari: [
        {
          day_name: "Senin",
          day_code: 1,
        },
        {
          day_name: "Selasa",
          day_code: 2,
        },
        {
          day_name: "Rabu",
          day_code: 3,
        },
        {
          day_name: "Kamis",
          day_code: 4,
        },
      ],
      alert: {
        show: false,
        msg: "",
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...helper,
    doLogout() {
      this.logout();
      this.$router.push("/login").catch(() => { });
    },
    async getRembug(day = "") {
      this.$store.commit("setLoading", true);
      let hari_transaksi = new Date().getDay();

      if (day == "") {
        hari_transaksi = this.user.hari_transaksi;
      } else {
        hari_transaksi = day;
      }

      let payload = new FormData();
      payload.append("fa_code", this.user.fa_code);
      payload.append("hari_transaksi", hari_transaksi);
      try {
        let req = await services.infoRembug(payload, this.user.token);
        if (req.status === 200) {
          if (Array.isArray(req.data.data)) {
            this.rembug = req.data.data;
            this.rembug.map((item) => {
              const kode_rembug = item.kode_rembug || item.cm_code || null;
            });
          } else {
            this.alert = {
              show: true,
              msg: "Rembug tidak ditemukan",
            };
          }
        } else {
          this.alert = {
            show: true,
            msg: data.message,
          };
        }
      } catch (error) {
        this.alert = {
          show: true,
          msg: error,
        };
      }
      this.$store.commit("setLoading", false);
    },
    getDate() {
      let today = new Date();
      let day = today.getDate();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      return `${year}-${month}-${day}`;
    },
  },
  mounted() {
    const today = new Date();

    // set tanggal hari ini format YYYY-MM-DD
    const year = today.getFullYear();
    const month = ("0" + (today.getMonth() + 1)).slice(-2);
    const day = ("0" + today.getDate()).slice(-2);

    this.transaction_date = `${year}-${month}-${day}`;

    // ambil hari sekarang
    let dayNow = today.getDay(); // 0 = Minggu

    // karena opsi hanya Senin-Kamis
    if (dayNow === 0) dayNow = 1; // Minggu → Senin
    if (dayNow > 4) dayNow = 4;   // Jumat/Sabtu → Kamis

    this.selectedItem = dayNow;

    // load data otomatis
    this.getRembug(dayNow);
  }
};
</script>
<style scoped>
/* CARD */
.card-modern {
  border-radius: 18px;
  padding: 18px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

.card-modern:active {
  transform: scale(0.98);
}

/* ANGKA */
.anggota-count {
  color: #8e24aa;
}

/* BUTTON */
.btn-modern {
  background: linear-gradient(135deg, #8e24aa, #E2BBE9);
  color: white;
  font-weight: 600;
  border-radius: 12px;
  text-transform: none;
  letter-spacing: 0.4px;
}

.v-icon {
  opacity: 0.8;
}
</style>
